// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"097c7763","161":"1ecf3cab","257":"56288b62","439":"edced538"}[chunkId] + ".css";
};